import granada101 from "./granada10-1.webp";
import granada102 from "./granada10-2.webp";

const granada10 = [granada101, granada102];

export default granada10;
